<div
  style="min-height: 24px; max-height: 24px; min-width: 24px; max-width: 24px;"
  class="svg__wrapper"
>
  <svg
    version="1.1"
    id="location-svg"
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    viewBox="0 0 24 24"
    style="enable-background:new 0 0 24 24; min-height: 24px; max-height: 24px; min-width: 24px; max-width: 24px;"
    xml:space="preserve"
    class="svg"
  >
    <path
      class="st0"
      d="M-5-2.6h27v27H-5V-2.6z"
      style="fill:none;"
    />
    <path
      class="st1"
      d="M8.5,0.7c-4.4,0-7.9,3.5-7.9,7.9c0,5.9,7.9,14.6,7.9,14.6s7.9-8.7,7.9-14.6C16.4,4.3,12.9,0.7,8.5,0.7z"
      style="fill:none;stroke:#000000;stroke-width:0.8;stroke-miterlimit:10;"
    />
    <circle
      class="st1"
      cx="8.5"
      cy="8.6"
      r="2.8"
      style="fill:none;stroke:#000000;stroke-width:0.8;stroke-miterlimit:10;"
    />
  </svg>
</div>